import { PROGRAMATICALLY_FOCUSABLE, TAB_FOCUSABLE } from "./constants";
/**
 * Checks if an element is focusable.
 *
 * @see {@link ElementFocusType}
 * @remarks \@since 2.8.0
 * @param element - The element to check
 * @param type - The focus type to compare against
 * @returns true if the element is focusable
 */
export function isFocusable(element, type) {
    if (type === void 0) { type = "programmatic"; }
    return ("matches" in element &&
        element.matches(type === "programmatic" ? PROGRAMATICALLY_FOCUSABLE : TAB_FOCUSABLE));
}
//# sourceMappingURL=isFocusable.js.map